import { createSlice } from '@reduxjs/toolkit';

import { TRACKING_DEFAULT_PARAMS } from '../../constants/tracking';
import { IPageState } from '../../types/page';

const initialState: IPageState = {
  subdomain: undefined,
  tracking: TRACKING_DEFAULT_PARAMS,
  isContactsVisible: false,
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {},
  selectors: {
    selectTracking: state => state.tracking,
    selectTrackingProducts: state => state.tracking.products,
    selectIsContactsVisible: state => state.isContactsVisible,
  },
});

export const {
  reducer: pageReducer,
  // eslint-disable-next-line no-empty-pattern
  actions: {},
  selectors: { selectTracking, selectTrackingProducts, selectIsContactsVisible },
} = pageSlice;
